import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {PackageSpotsPipe} from "../../../../commons/angular/pipes/package-spots.pipe";
import {Service} from "../../../models/service.model";

require('./service-task-pods.scss');
@Component({
  standalone: false,
  selector: 'app-service-task-pods',
  templateUrl: './service-task-pods.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceTaskPodsComponent implements OnInit, OnChanges {

  @Input() service: Service;

  public podsCount: number;

  constructor(@Inject('deliveriesDialogService') private deliveriesDialogService) {
  }

  ngOnInit() {
    this.initData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.service && !changes.service.isFirstChange()) {
      this.initData();
    }
  }

  onClick() {
    this.deliveriesDialogService.viewServiceIdentification(this.service);
  }

  private initData() {
    this.podsCount = 0;
    this.service.taskList.forEach((t) => {
      if (!!t.taskSpec.identifications) {
        Object.entries(t.taskSpec?.identifications).forEach(([key, value], index) => {
          if (key.includes('BlobName')) {
            this.podsCount += 1;
          }
        });
      }
    })
  }

}
